import { render } from "./payment-gateway.vue?vue&type=template&id=3eecf42c&scoped=true"
import script from "./payment-gateway.vue?vue&type=script&lang=js"
export * from "./payment-gateway.vue?vue&type=script&lang=js"

import "./payment-gateway.vue?vue&type=style&index=0&id=3eecf42c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eecf42c"]])

export default __exports__